<template>
  <div>
    <common-dialog ref="dialog" width="500px" line-form show-save-button unit="属性" edit-title id-key="DataId"
      :data="data" @create-opened="onCreateOpened" @edit-opened="onEditOpened"  :form-rules="rules" :save-func="api.save" :get-data-func="api.info" @close="onClosed"
      @close-saved="$emit('close-saved')">
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row :gutter="15">
            <el-col>
              <el-form-item label="标签名称" prop="DataName">
                <el-input v-model="data.DataName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="row-tb-head" style="margin-top: 10px">
          <span>产品信息</span>
          <div style="float: right">
            <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
          </div>
        </div>
        <el-table ref="table" class="table-line tb-c-head" :data="data.Contacts" border>
          <el-table-column label="标签编号" min-width="110">
            <template slot-scope="{ row }">
              <el-input @input="onInput(row, 'Code')" v-model="row.Code"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="标签内容" min-width="110">
            <template slot-scope="{ row }">
              <el-input @input="onInput(row, 'Text')" v-model="row.Text"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="60px">
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click="del(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer"> </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      params: {},
      data: {
        DataId: 0,
        DataName: "",
        DataType: 0,
        IsDefault: false,
        Contacts: [],
      },
      api: require("@/api/sy/enumdata").default,
      rules: {
        DataName: [{ required: true, message: "标签名称不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened() {
      this.api.list(this.params).then((res) => {
        this.data = res;
      });
    },
    onEditOpened(data){
      console.log(data);
    },
    onInput(row, type) { },
    add() {
      this.data.Contacts.push({
        T: 0,
        Text: "",
        Code: "",
        Sn: 0,
        Status: 1,
      });
    },
    del(row, index) {
      this.data.Contacts.splice(index, 1);
    },
    onClosed(){
      this.data.Contacts=[]
    }
  },
};
</script>